type HomeRecentUpdatesTourApi = {
  scrollToCommentPost: (options?: { smooth?: boolean }) => boolean;
};

let api: HomeRecentUpdatesTourApi | null = null;

export const registerHomeRecentUpdatesTourApi = (
  next: HomeRecentUpdatesTourApi | null
): void => {
  api = next;
};

/** Scroll the feed to the first Common room card so its comment CTA can mount. */
export const scrollToHomeRecentUpdatesCommentPost = (options?: {
  smooth?: boolean;
}): boolean => api?.scrollToCommentPost(options) ?? false;
